import axios from 'axios';
import { baseURL } from '../baseURL';
import Cookies from 'js-cookie';

export const createBuyer = async ({ name, lastname, password, email, userType, phone }) => {
    const { data } = await axios.post(
        `${baseURL}amantrans/moderators/add`,
        { name, lastname, password, email, userType, phone, filialId: 1 },
        {
            headers: {
                Authorization: `Bearer ${Cookies.get('token')}`,
            },
        },
    );

    return data;
};
